<h1>Mi Perfil</h1>
<div class="mat-elevation-z4 divmarco">
  <!--h1>Información de Usuario</h1>
  <hr-->
  <div fxLayout="row" fxLayoutAlign="space-around start" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
    class="divconten">
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">person</mat-icon>
          <span class="font-size-16">Datos del Representante</span>
        </ng-template>
        <mat-list role="list">
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Nombre y Apellido:&nbsp;</span><span class="font-size-14"> {{ userFullName }}
            </span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Correo Electrónico:&nbsp;</span><span
              class="font-size-14"> {{ userEmail }} </span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Teléfono:&nbsp;</span><span class="font-size-14"> {{ userphoneNumber }} </span>
            </mat-list-item>
            <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Perfil:&nbsp;</span><span class="font-size-14"> {{ userProfile }} </span>
          </mat-list-item>
        </mat-list>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="example-tab-icon">apartment</mat-icon>
          <span class="font-size-16">Datos de la Empresa y Licencias</span>
        </ng-template>
        <mat-list role="list">
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Razón Social:&nbsp;</span><span class="font-size-14"> {{ companyName }} </span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Número de RIF:&nbsp;</span><span
              class="font-size-14"> {{ companyRif }} </span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Número de Teléfono:&nbsp;</span><span
              class="font-size-14"> {{ companyphoneNumber }} </span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Correo Electrónico:&nbsp;</span><span class="font-size-14"> {{ companyEmail }}
            </span>
            </mat-list-item>
            <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Ciudad:&nbsp;</span><span class="font-size-14"> {{ companyFiscalAddress }}
            </span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Serial:&nbsp;</span><span
              class="font-size-14">{{ licenseSerial }}</span>
          </mat-list-item>
          <!-- <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Número de Licencias:&nbsp;</span><span class="font-size-14">
              {{companyLicenseNumber}} </span>
          </mat-list-item> -->
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Licencia desde:&nbsp;</span><span class="font-size-14">{{ licenseFrom
              }}</span>
          </mat-list-item>
          <mat-list-item role="listitem">
            <span class="span-negrita font-size-14">Licencia hasta:&nbsp;</span><span class="font-size-14">{{ licenseTo }}</span>
          </mat-list-item>
        </mat-list>
      </mat-tab>
    </mat-tab-group>

  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
    class="divconten">
    <div fxLayout="column">
      <button mat-raised-button (click)="navigateMenu();" color="warn" type="button" class="align-center-middle">
        <span class="text-icon-space">Regresar a Home</span>
        <mat-icon>home</mat-icon>
      </button>
    </div>
  </div>
</div>